module.exports = __webpack_public_path__ + "img/img-33.7227163f.png";